import { post } from 'src/tools/server';
//portal/stockSupplier
const addBrand = (body) => {
  return post(`/portal/brand`, body, {});
};
export { addBrand };
